import { render, staticRenderFns } from "./IconPreview.vue?vue&type=template&id=0d1016a1&"
import script from "./IconPreview.vue?vue&type=script&lang=ts&"
export * from "./IconPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports